// Date-only arithmetic never uses the browser timezone or 24-hour DST assumptions.
export function businessDate(timeZone, instant = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-US", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(instant).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}
export const addLocalDays = (value, days) => {
  const date = new Date(`${value}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};
export function monthBounds(value) {
  const first = `${value.slice(0, 7)}-01`;
  return [first, addLocalDays(shiftMonth(first, 1), -1)];
}
export function shiftMonth(value, direction) {
  const date = new Date(`${value.slice(0, 7)}-01T12:00:00Z`);
  date.setUTCMonth(date.getUTCMonth() + direction);
  return date.toISOString().slice(0, 10);
}
export function operationsBounds(view, range, anchor, today) {
  if (view === "today") return [today, today];
  if (view === "upcoming") return [addLocalDays(today, 1), addLocalDays(today, 30)];
  if (view === "needsAction" || range === "month") return monthBounds(anchor);
  if (range === "day") return [anchor, anchor];
  const day = new Date(`${anchor}T12:00:00Z`).getUTCDay();
  const first = addLocalDays(anchor, -((day + 6) % 7));
  return [first, addLocalDays(first, 6)];
}
export const OPERATIONS_PAGE_SIZE = 50;

// Persist only view preferences, never rows or financial data. Each business gets its own scope.
export function readOperationsView(business) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(`scheduling-view:${business}`));
    return { display: saved?.display === "calendar" || saved?.mode === "calendar" ? "calendar" : "list" };
  } catch { return { display: "list" }; }
}
export function saveOperationsView(business, {display}) {
  try { sessionStorage.setItem(`scheduling-view:${business}`, JSON.stringify({display})); } catch { /* Storage may be disabled. Reads and navigation still work. */ }
}
